import React from "react";

const Hero = () => {
  return (
    <section
      id="home"
      className="hero"
      style={{
        background: "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)",
        padding: "60px 0",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Left Column */}
          <div
            className="col-12 col-lg-7 text-center text-lg-start"
            data-aos="fade-right"
          >
            <div className="mb-4">
              <span
                className="d-inline-block"
                style={{
                  backgroundColor: "#1a3e3f",
                  color: "#e8d5b5",
                  padding: "8px 20px",
                  borderRadius: "50px",
                  fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                  fontWeight: "600",
                  letterSpacing: "1px",
                }}
              >
                WELCOME TO
              </span>
            </div>

            {/* Logo / Company Name */}
            <div style={{ marginBottom: "25px" }}>
              <h1
                style={{
                  fontSize: "clamp(2.5rem, 6vw, 3.5rem)",
                  fontWeight: "700",
                  color: "#1a3e3f",
                  lineHeight: "1.2",
                  marginBottom: "5px",
                }}
              >
                PT CITRA
              </h1>
              <h1
                style={{
                  fontSize: "clamp(2.5rem, 6vw, 3.5rem)",
                  fontWeight: "700",
                  color: "#b68b40",
                  lineHeight: "1.2",
                  marginBottom: "10px",
                }}
              >
                AROMA INDO
              </h1>
              <div
                style={{
                  width: "100px",
                  height: "4px",
                  background: "linear-gradient(90deg, #b68b40, #e8d5b5)",
                  marginTop: "15px",
                  borderRadius: "2px",
                }}
                className="mx-auto mx-lg-0"
              />
            </div>

            <p
              style={{
                fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
                color: "#4a5568",
                marginBottom: "30px",
                lineHeight: "1.8",
                maxWidth: "100%",
              }}
              className="mx-auto mx-lg-0"
            >
              Premium producer and distributor of high-quality patchouli oil for
              domestic and international markets.
            </p>

            {/* Buttons */}
            <div className="d-flex flex-column flex-sm-row gap-3 mb-4 justify-content-center justify-content-lg-start">
              <a
                href="#about"
                className="btn rounded-pill px-4 px-lg-5 py-3"
                style={{
                  backgroundColor: "#b68b40",
                  borderColor: "#b68b40",
                  color: "white",
                  fontWeight: "600",
                  fontSize: "clamp(0.9rem, 2vw, 1rem)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#b68b40";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#b68b40";
                  e.target.style.color = "white";
                }}
              >
                About Us
              </a>
              <a
                href="#contact"
                className="btn rounded-pill px-4 px-lg-5 py-3"
                style={{
                  backgroundColor: "transparent",
                  borderColor: "#1a3e3f",
                  color: "#1a3e3f",
                  fontWeight: "600",
                  fontSize: "clamp(0.9rem, 2vw, 1rem)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#1a3e3f";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#1a3e3f";
                }}
              >
                Contact Us
              </a>
            </div>

            {/* Company Values */}
            <div className="d-flex flex-wrap gap-4 mt-4 justify-content-center justify-content-lg-start">
              <div className="d-flex align-items-center">
                <span style={{ fontSize: "1.5rem", color: "#b68b40" }}>✓</span>
                <span
                  style={{
                    marginLeft: "8px",
                    color: "#1a3e3f",
                    fontWeight: "500",
                    fontSize: "clamp(0.9rem, 2vw, 1rem)",
                  }}
                >
                  Quality
                </span>
              </div>
              <div className="d-flex align-items-center">
                <span style={{ fontSize: "1.5rem", color: "#b68b40" }}>✓</span>
                <span
                  style={{
                    marginLeft: "8px",
                    color: "#1a3e3f",
                    fontWeight: "500",
                    fontSize: "clamp(0.9rem, 2vw, 1rem)",
                  }}
                >
                  Sustainability
                </span>
              </div>
              <div className="d-flex align-items-center">
                <span style={{ fontSize: "1.5rem", color: "#b68b40" }}>✓</span>
                <span
                  style={{
                    marginLeft: "8px",
                    color: "#1a3e3f",
                    fontWeight: "500",
                    fontSize: "clamp(0.9rem, 2vw, 1rem)",
                  }}
                >
                  Integrity
                </span>
              </div>
            </div>
          </div>

          {/* Right Column - Logo / Brand Image */}
          <div className="col-12 col-lg-5 text-center" data-aos="fade-left">
            <div
              style={{
                position: "relative",
                display: "inline-block",
                maxWidth: "100%",
              }}
            >
              {/* Logo Circle */}
              <div
                style={{
                  width: "min(400px, 80vw)",
                  height: "min(400px, 80vw)",
                  background: "white",
                  borderRadius: "50%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 25px 40px rgba(26,62,63,0.3)",
                  border: "8px solid rgba(232,213,181,0.15)",
                  margin: "0 auto",
                }}
              >
                <img
                  style={{
                    fontSize: "clamp(4rem, 15vw, 6rem)",
                    color: "#e8d5b5",
                    marginBottom: "10px",
                    width: "95%",
                    height: "95%",
                    borderRadius: "50%",
                    objectFit: "contain",
                  }}
                  src="/logoCAI.svg"
                  alt="logo"
                ></img>
              </div>

              {/* Floating Badge 1 - Tahun Berdiri (hidden on mobile) */}
              <div
                className="d-none d-md-block"
                style={{
                  position: "absolute",
                  top: "30px",
                  right: "-10px",
                  backgroundColor: "white",
                  padding: "12px 20px",
                  borderRadius: "15px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                  borderLeft: "4px solid #b68b40",
                }}
                data-aos="fade-left"
                data-aos-delay="200"
              >
                <span style={{ fontWeight: "600", color: "#1a3e3f" }}>
                  15+ Years
                </span>
                <br />
                <span style={{ fontSize: "0.8rem", color: "#6c757d" }}>
                  Experience
                </span>
              </div>

              {/* Floating Badge 2 - Lokasi (hidden on mobile) */}
              <div
                className="d-none d-md-block"
                style={{
                  position: "absolute",
                  bottom: "40px",
                  left: "-10px",
                  backgroundColor: "white",
                  padding: "12px 20px",
                  borderRadius: "15px",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                  borderLeft: "4px solid #b68b40",
                }}
                data-aos="fade-right"
                data-aos-delay="300"
              >
                <span style={{ fontWeight: "600", color: "#1a3e3f" }}>
                  🇮🇩 Indonesia
                </span>
                <br />
                <span style={{ fontSize: "0.8rem", color: "#6c757d" }}>
                  Makassar
                </span>
              </div>
            </div>

            {/* Trust Indicators */}
            <div className="d-flex justify-content-center gap-2 gap-lg-3 mt-5 flex-wrap">
              <span
                className="badge"
                style={{
                  backgroundColor: "#f8f9fa",
                  color: "#1a3e3f",
                  padding: "8px 16px",
                  borderRadius: "50px",
                  fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                  fontWeight: "500",
                  border: "1px solid #edf2f7",
                }}
              >
                🌱 100% Natural
              </span>
              <span
                className="badge"
                style={{
                  backgroundColor: "#f8f9fa",
                  color: "#1a3e3f",
                  padding: "8px 16px",
                  borderRadius: "50px",
                  fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                  fontWeight: "500",
                  border: "1px solid #edf2f7",
                }}
              >
                🔬 Lab Tested
              </span>
              <span
                className="badge"
                style={{
                  backgroundColor: "#f8f9fa",
                  color: "#1a3e3f",
                  padding: "8px 16px",
                  borderRadius: "50px",
                  fontSize: "clamp(0.8rem, 2vw, 0.9rem)",
                  fontWeight: "500",
                  border: "1px solid #edf2f7",
                }}
              >
                📦 Export Quality
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
